export const SearchTypeAI = 30 as const;
export type TSearchTypeAI = typeof SearchTypeAI;
